import React, { useContext, useState } from "react";
import dishes, { allImages, gallery } from "./data";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  const [sidebarOn, setSidebarOn] = useState(false);

  const openSidebar = () => {
    setSidebarOn(true);
  };

  const closeSidebar = () => {
    setSidebarOn(false);
  };

  return (
    <AppContext.Provider
      value={{
        dishes,
        allImages,
        gallery,
        openSidebar,
        closeSidebar,
        sidebarOn,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};
